import useVersionCheck from '@/hooks/use-version-check';
import { App, Button } from 'antd';
import { useEffect } from 'react';

const NOTIFICATION_KEY = 'app-version-update';

/** 새 배포 감지 시 새로고침을 유도하는 알림을 띄운다. 렌더링되는 UI는 없다. */
export default function VersionUpdateWatcher() {
  const hasNewVersion = useVersionCheck();
  const { notification } = App.useApp();

  useEffect(() => {
    if (!hasNewVersion) return;

    notification.info({
      key: NOTIFICATION_KEY,
      message: '새 버전이 배포되었습니다',
      description:
        '최신 화면을 이용하려면 새로고침해 주세요. 새로고침 후에도 계속 노출된다면 창을 닫고 잠시 후 다시 접속해 주세요.',
      duration: 0,
      btn: (
        <Button
          type="primary"
          size="small"
          onClick={() => {
            window.location.reload();
          }}
        >
          새로고침
        </Button>
      ),
    });
  }, [hasNewVersion, notification]);

  return null;
}
